module.exports = __webpack_public_path__ + "static/save-money-with-camelo-scheduling-15da33f44244e722b9d993d672bd2098.svg";